<template>
  <div v-if="showSwitch" class="auto-categories-filter">
    <div class="auto-categories-filter__title">
      <v-icon color="black" class="mr-2">icon-robot</v-icon>
      {{ $t("message.reviews.categories.showOnlyAutoAssignedCategories") }}
    </div>

    <v-switch
      v-model="showOnlyAutoCategorized"
      inset
      hide-details
      @change="$emit('change', $event)"
    ></v-switch>
  </div>
</template>

<script>
import { PLAN_RESTRICTIONS } from "@/enums/plan-restrictions";
import { planRestrictionsCheck } from "@/helpers/plan-restrictions-check";

export default {
  name: "ReviewsCategoriesAutoFilter",
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showOnlyAutoCategorized: false
    };
  },
  created() {
    this.showOnlyAutoCategorized = this.value;
  },
  computed: {
    showSwitch() {
      return planRestrictionsCheck(
        PLAN_RESTRICTIONS.CAN_USE_SENTIMENT_ANALYSIS
      );
    }
  }
};
</script>

<style lang="scss" scoped>
.auto-categories-filter {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: $spacing * 2;

  &__title {
    display: flex;
    align-items: center;
  }

  ::v-deep .v-input {
    margin: 0;
  }
}
</style>
